import React from 'react';
import HeroSection from '../components/hero-components/HeroSection';

export default function Home() {
    return (
        <div className="main-section">
            <HeroSection />
        </div>
    )
}